import { apmBase } from "@elastic/apm-rum";

/**
 * Captures a network-level Apollo error (HTTP failure, DNS failure, timeout, etc.).
 * Called from the Apollo errorHandlerLink for real transport errors.
 */
export function captureApolloNetworkError(error: Error): void {
  if (import.meta.env.APP_APM_ENABLED !== "true") return;
  apmBase.captureError(error);
}

/**
 * Captures an unexpected GraphQL error (not UserLocked / PasswordExpired, which are
 * expected business-logic flows handled via broadcast events).
 */
export function captureApolloGraphQLError(error: { message: string }): void {
  if (import.meta.env.APP_APM_ENABLED !== "true") return;
  apmBase.captureError(new Error(`GraphQL: ${error.message}`));
}
